import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  path: {
    fill: '#7df3e1',
  },
});


export const LogoFull = () => {
  return (
    <div>
      <img src="/logo.png" alt="logo" style={{ height: 40, width: 'auto', marginLeft: -10}}/>
    </div>
  );
};
